
import { Component, Prop, mixins } from "nuxt-property-decorator"
import Blocks from "~/mixins/blocks"

@Component
export default class PageLayoutRemovalsHub extends mixins(Blocks) {
  @Prop({ required: true }) page: Record<string, any>

  blocks: Array<Record<string, any>> = []

  created() {
    this.blocks = [...this.page?.blocks]
  }

  isGeocityCategory() {
    const category = this.page.categories.nodes.find(category => category.slug === "geocity")

    return !!category
  }
}
